import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { DimensionServiceController } from './dimension-service.controller';
import { Dimension } from './dimension-service.entity';
import { DimensionServiceService } from './dimension-service.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([Dimension]),
  ],
  controllers: [DimensionServiceController],
  providers: [DimensionServiceService,ApplicationExceptionHandler]
})
export class DimensionServiceModule {}
